import type {
  ActionsBarDropdownItem,
  ActionsBarItem,
} from "./actions-bar.type";

export const getActionsBarPrimaryItems = (
  primaryActions?: ActionsBarItem[]
): ActionsBarItem[] => {
  return (primaryActions ?? []).filter((action) => !action.hidden);
};

export const getActionsBarSecondaryItems = (
  secondaryActions?: ActionsBarItem[]
): ActionsBarDropdownItem[] => {
  return (secondaryActions ?? [])
    .filter((action) => !action.hidden)
    .map((action) => ({ key: action.key, label: action.node }));
};
